import { LoadingStatusType, TypeComponentNoti } from "@/enums/enums";
import { GetMessageExceptionCode } from "@/helper/shareHelper";
import { MerchantModel } from "@/model/merchant/merchantModel";
import API from "@/service/Index";
import { ConvertToMerchantAddress, ConvertToMerchantDetail } from "@/service/merchant/merchantFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { MerchantAddressModel } from "./../../model/address/addressModel";

@Module({ namespaced: true })
export default class Merchant extends VuexModule {
  private merchantDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private merchantDetail: MerchantModel | null = null;
  private merchantAddressListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private merchantAddressList: Array<MerchantAddressModel> = [];
  private merchantQRPaymentSettingLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private merchantQRPaymentModel: any = null;

  get getMerchantDetailLoadingStatus(): LoadingStatusType {
    return this.merchantDetailLoadingStatus;
  }
  get getMerchantDetail(): MerchantModel | null {
    return this.merchantDetail;
  }
  get getMerchantAddressListLoadingStatus(): LoadingStatusType {
    return this.merchantAddressListLoadingStatus;
  }
  get getMerchantAddressList(): Array<MerchantAddressModel> {
    return this.merchantAddressList;
  }
  get getMerchantQRPaymentSettingLoadingStatus(): LoadingStatusType {
    return this.merchantQRPaymentSettingLoadingStatus;
  }
  get getMerchantQRPaymentModel(): any {
    return this.merchantQRPaymentModel;
  }

  @Mutation
  public MutationMerchantDetailLoadingStatus(loadingStatus: LoadingStatusType) {
    this.merchantDetailLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationMerchantDetail(merchantDetail: MerchantModel) {
    this.merchantDetail = merchantDetail;
  }
  @Mutation
  public MutationMerchantAddressListLoadingStatus(loadingStatus: LoadingStatusType) {
    this.merchantAddressListLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationMerchantAddressList(addressList: Array<MerchantAddressModel>) {
    this.merchantAddressList = addressList;
  }
  @Mutation
  public MutationMerchantQRPaymentSettingLoadingStatus(loadingStatus: LoadingStatusType) {
    this.merchantQRPaymentSettingLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationMerchantQRPaymentModel(merchantQRPaymentModel: any) {
    this.merchantQRPaymentModel = merchantQRPaymentModel;
  }

  @Action
  public DoGetMerchantDetail() {
    if (this.merchantDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationMerchantDetailLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetMerchantDetail().then((res: any) => {
        if (res.status.IsSuccess()) {
          const detail = ConvertToMerchantDetail(res.data.data);
          this.context.commit("MutationMerchantDetail", detail);
          this.context.commit("MutationMerchantDetailLoadingStatus", LoadingStatusType.Success);
          if (detail.isUsePassCodeOnPublicLink) {
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          }
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
          this.context.commit("MutationMerchantDetailLoadingStatus", LoadingStatusType.Fail);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
      });
    }
  }

  @Action
  public DoGetMerchantAddressList() {
    if (this.merchantAddressListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationMerchantAddressListLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetMerchantAddressList().then((res: any) => {
        if (res.status.IsSuccess()) {
          const addressList = ConvertToMerchantAddress(res.data.addressList);
          this.context.commit("MutationMerchantAddressList", addressList);
        }
        this.context.commit("MutationMerchantAddressListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetCheckQRPayment() {
    return new Promise((resolve, reject) => {
      API.MerchantService.DoGetMerchantDetail().then((res: any) => {
        if (res.status.IsSuccess()) {
          const detail = ConvertToMerchantDetail(res.data.data);
          this.context.commit("MutationMerchantDetail", detail);
          resolve(detail);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
          this.context.commit("MutationMerchantDetailLoadingStatus", LoadingStatusType.Fail);
          reject();
        }
      });
    });
  }
  @Action
  public DoGetQRPaymentSetting() {
    if (this.merchantQRPaymentSettingLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationMerchantQRPaymentSettingLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetQRPaymentSetting().then((res: any) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationMerchantQRPaymentModel", res.data.data);
        } else {
          this.context.commit("MutationMerchantQRPaymentModel", null);
        }
        this.context.commit("MutationMerchantQRPaymentSettingLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
}
